import React from 'react';
import TermsAndConditions from '../common/TermsAndConditions/TermsAndConditions';
import PosterAndVideo from './PosterAndVideo';

const HowItWorks = () => {
  return (
    <div className="ptp-splash-page__how-it-works">
      <p className="ptp-splash-page__card-title ptp-hidden__sm-up">How It Works</p>
      <div className="ptp-splash-page__text-and-video">
        <PosterAndVideo
          posterImage="https://assets.thdstatic.com/images/v1/path-to-pro/HIW-1.png"
          videoSrc="https://assets.thdstatic.com/images/v1/path-to-pro/path_to_pro_overview_&_testimonials.webm"
        />
        <div className="ptp-splash-page__how-it-works-text-container">
          <p className="ptp-splash-page__card-title ptp-hidden__xs-down">How It Works</p>
          <p className="ptp-splash-page__video-paragraph">
            The Path to Pro Network gives you the ability to connect with the skilled tradespeople
            your
            business needs. You can find tradespeople by trade, location, and availability. View
            each
            jobseeker’s work portfolio, experience level, and qualifications all in one place!
          </p>
          <p className="ptp-splash-page__video-paragraph"><b>¿Hablas español?</b> Accede a los{' '}
            <a
              className="ptp-splash-page__hyperlink"
              target="_blank"
              rel="noreferrer"
              href="https://www.pathtopro.com/es/resources-library/"
            >
              recurso aquî
            </a>.
          </p>
          <p className="ptp-splash-page__video-paragraph">To learn more, visit {' '}
            <a
              className="ptp-splash-page__hyperlink"
              target="_blank"
              rel="noreferrer"
              href="https://www.pathtopro.com/"
            >PathToPro.com
            </a>.
          </p>
        </div>
      </div>
      <div className="ptp-splash-page__video-paragraph">
        <TermsAndConditions />
      </div>
    </div>
  );
};
export default HowItWorks;
